export default "/_next/static/chunks/fonts/Feather-e2c96dfb09d9f69ec7cfb6d5c3d583c6.ttf";